const dispatchPresenterChanged = (presenterName: string, presenterId: string) => {
    let event = new CustomEvent('BidAgentPresenterChanged', {
        detail: {
            presenterName: presenterName,
            presenterId: presenterId,
        }
    });
    window.dispatchEvent(event)
}

export {
    dispatchPresenterChanged
}